import React, { useState } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import BubbleComponent from "./bubble-component";
import Title from "./title";
import Background from "./background";
import useDelayUnmount from "./hooks/useDelayUnmount";
import style from "./style";

const Modal = dynamic(() => import("./modal"));

const Ecosystem = (props) => {
  const sectionProps = props["SectionDescription"];
  const { skeletonClassName } = props;
  const backgroundProps = sectionProps["Background-1"];
  const mainBubble = props["Item-Main"];
  const auxBubbles = Object.keys(props)
    .filter((key) => key.startsWith("Item") && !key.endsWith("Main"))
    .map((key) => props[key]);
  const taggingInfo = props["taggingInfo"];

  const [isActive, setIsActive] = useState(false);
  const [currentBubble, setCurrentBubble] = useState(0);
  const [playVideo, setPlayVideo] = useState(false);

  const shouldRender = useDelayUnmount(isActive, 400);

  const openBubbleHandler = (i) => {
    setCurrentBubble(i);
    setIsActive(true);
  };

  const closeBubbleHandler = () => {
    setIsActive(false);
  };

  return (
    <>
      <section className="ecosystem" data-cy="Section Ecosystem" onMouseEnter={() => setPlayVideo(true)}>
        <Background
          videoWebM={backgroundProps["Video-1"]}
          videoMP4={backgroundProps["Video-2"]}
          image={backgroundProps["Image-1"]}
          playVideo={playVideo}
        />
        <div className="content container" data-cy="Ecosystem Content">
          <Title
            title={sectionProps["Text-1"]}
            subTitle={sectionProps["Text-2"]}
            isOpen={isActive}
          />
          <BubbleComponent
            setBubble={openBubbleHandler}
            isActive={isActive}
            currentBubble={currentBubble}
            mainBubble={mainBubble}
            auxBubbles={auxBubbles}
            taggingInfo={taggingInfo}
          />
        </div>
        {shouldRender && (
          <Modal
            isOpen={isActive}
            closeModal={closeBubbleHandler}
            modalData={props[`Item-${currentBubble + 1}`]["Card-1"]}
            taggingInfo={taggingInfo}
          />
        )}

        <div className={skeletonClassName} />
      </section>
      <style jsx>{style}</style>
    </>
  );
};

export default Ecosystem;

Ecosystem.propTypes = {};
Ecosystem.defaultProps = {};
